require('./job_apply_forms');
require('./step_basic_info');
require('./step_resume_info');
require('./step_additional_info');
require('./step_review');

$(() => {
  const formStepContainers = $('.form-step-container');

  let maxHeight = 0;
  formStepContainers.each(function() {
    const height = $(this).outerHeight(); // Call outerHeight as a method

    if (maxHeight < height) {
      maxHeight = height;
    }
  });

  formStepContainers.css('min-height', maxHeight+'px');
});
